import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import MoveTypeDropDown from "../../../uiControls/MoveTypeDropDown";
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';

import {
  DateRenderer,DateTimeRenderer,TextAlignLeftWithAddressTooltipRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {JobNames} from "../../../framework.core/JobNames";
import {oceanExportBookingList} from "../tableSettings";
import {OeBookingListItem} from "../../../fms.data/models/OeBookingListItem";
import IfmsModal from "../../../ui/IfmsModal";
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import * as XCol from '../../../framework.core/XExportColumn';
import { FmsSecTask } from '../../../fms.core/constants';
import { findSecurityTask } from '../../../util';
import constants from '../../../constants';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import useSetEditedId from '../../../hooks/useSetEditedId';

function MoveTypeFilterRenderer({value, onChange}: any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}      
    />
  );
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  let content: React.ReactNode = <></>;
  
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}


function useOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(b:OeBookingListItem|null) {
    if (!b) {
      return;
    }

    if (b.hblNo) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeHbl/oceanExport', 
      'hblNo', 'HBL #', b.hblNo, 'u2Date', false, true);
    }
    else if (b.hBookingNo) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeHbl/oceanExport', 
      'hBookingNo', 'Booking #', b.hBookingNo, 'u2Date', false, true);
    }

    openNewPage(history, `/common/joblistview/oeHbl/oceanExport`, NavigationType.newPage);
  }

  return {switchToHblFor};
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const setOEHSavedEntity = useSetEditedId([JobNames.OEHbl]);

  const selectedElement = jobListContext.selectedElement as OeBookingListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const {switchToHblFor} = useOperations();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/booking/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, '/oceanExport/booking/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/booking/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/booking/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Booking first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OEBook, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setOEHSavedEntity(selectedElement.id.toString(), false, true);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null, 'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanExport/booking/edit/${id}`;
    const viewUrl = `/oceanExport/booking/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanExport/booking/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }
    const id = selectedElement.id;
    const editUrl = `/oceanExport/booking/edit/${id}`;
    const viewUrl = `/oceanExport/booking/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.OEBook);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/booking/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }
    const id = selectedElement.id;
    openNewPage(history, `/oceanExport/booking/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHbl() {
    const selectedElement = jobListContext.selectedElement as OeBookingListItem;
    switchToHblFor(selectedElement);
  }

  return {create, deleteItem, edit, view, copy, switchToHbl};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, switchToHbl } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OeBookingListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.OEBook);
  const hblSec = findSecurityTask(appContext, FmsSecTask.OEHbl);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel, disabled : !!selectedElement?.refNo },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false, hidden: !hblSec?.grantRead},
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: true, hidden: !listSec?.grantAdd },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px"  name="booking-list-sub-menu"  label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToHbl();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as OeBookingListItem;

  const {deleteItem, edit, view} = useSelectedOperations();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/booking/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OEBook, selectedElement, appContext, showGlobalYesNoDialog, null);
    if(args){
      viewReport(args, "", true);
    }
  }

  const listSec = findSecurityTask(appContext, FmsSecTask.OEBook);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel && !selectedElement.refNo;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='booking-list-add-button' display="primary" link="/oceanExport/booking/add" disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='booking-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='booking-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='booking-list-delete-button' disabled={!canBeDeleted} onClick={deleteItem} useText />
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const { create, copy, edit, view, switchToHbl } = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.OEBook);
  const hblSec = findSecurityTask(appContext, FmsSecTask.OEHbl);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [unprocessedFkey]
);

function doProcessFkey() {
  if (unprocessedFkey === 'F6') {
    if (hblSec.grantRead)
      switchToHbl();
  } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
  } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
  } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
  } else if (unprocessedFkey === "F9") {
    view();
  } else if (unprocessedFkey === "F11") {
    jobListContext.reloadData();
  } else if (unprocessedFkey === "F8") {
    jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
  }
  setUnprocessedFkey(null);
}

function onFunctionKey(fkey:string) {
  if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
    setUnprocessedFkey(fkey);
    return true;
  }

  return false;
}

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OEBook}
      jobId={(jobListContext.selectedElement as OeBookingListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      isSingleBl={(jobListContext.selectedElement as OeBookingListItem|null)?.sbl}
    />
  );
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const { copy } = useSelectedOperations();
  const listSec = findSecurityTask(appContext, FmsSecTask.OEBook);

  const selectedElement = jobListContext.selectedElement as OeBookingListItem;
  const hasSelectedRow = !!selectedElement;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/booking/add`);
  }

  return (
    <>
      <PrimaryButton name='booking-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
    </>
  )
}

/**
 * Concrete implementation for Booking List screen
 *
 * @class BookingListView
 * @extends {AbstractListView}
 */
class BookingListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OEBook,
      'OeBookingListItem',
      OeBookingListItem.calculateSearchParameters(search, OeBookingListItem.MapOeSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: OeBookingListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OEBook, 'OeBookingListItem',
      OeBookingListItem.calculateSearchParameters(search, OeBookingListItem.MapOeSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  OeBookingListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }

  /*getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanExportMbl;
  }*/

  getRowRenderers(): ListRowRenderer[] {
    return OeBookingListItem.getExportCollection().map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      if (x.dataIndex === "truckingCompanyName" || x.dataIndex === "puCargoLocationName") colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer;
      // { accessor:'hblCount', Cell: HblRenderer, Header: () => <span><u>HBL</u>(s)</span> },
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  oceanExportBookingList;
    const cols = OeBookingListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderAfterConfigureButton() {
    return <></>
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: OeBookingListItem) {
    return row && row.id ? `/oceanExport/booking/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Booking (S/O) List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default BookingListView;
